// Generated from SearchRegexParser.g4 by ANTLR 4.8
// jshint ignore: start
import antlr4 from 'antlr4/index';

var grammarFileName = "SearchRegexParser.g4";


var serializedATN = ["\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964",
    "\u0003\t1\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004\u0004\t\u0004",
    "\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0003\u0002\u0005\u0002\u000e",
    "\n\u0002\u0003\u0002\u0003\u0002\u0003\u0003\u0003\u0003\u0003\u0003",
    "\u0007\u0003\u0015\n\u0003\f\u0003\u000e\u0003\u0018\u000b\u0003\u0003",
    "\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0007",
    "\u0004 \n\u0004\f\u0004\u000e\u0004#\u000b\u0004\u0003\u0005\u0003\u0005",
    "\u0003\u0005\u0005\u0005(\n\u0005\u0003\u0006\u0003\u0006\u0003\u0006",
    "\u0003\u0006\u0003\u0006\u0005\u0006/\n\u0006\u0003\u0006\u0002\u0003",
    "\u0006\u0007\u0002\u0004\u0006\b\n\u0002\u0002\u00020\u0002\r\u0003",
    "\u0002\u0002\u0002\u0004\u0011\u0003\u0002\u0002\u0002\u0006\u0019\u0003",
    "\u0002\u0002\u0002\b\'\u0003\u0002\u0002\u0002\n.\u0003\u0002\u0002",
    "\u0002\f\u000e\u0005\u0004\u0003\u0002\r\f\u0003\u0002\u0002\u0002\r",
    "\u000e\u0003\u0002\u0002\u0002\u000e\u000f\u0003\u0002\u0002\u0002\u000f",
    "\u0010\u0007\u0002\u0002\u0003\u0010\u0003\u0003\u0002\u0002\u0002\u0011",
    "\u0016\u0005\u0006\u0004\u0002\u0012\u0013\u0007\u0006\u0002\u0002\u0013",
    "\u0015\u0005\u0006\u0004\u0002\u0014\u0012\u0003\u0002\u0002\u0002\u0015",
    "\u0018\u0003\u0002\u0002\u0002\u0016\u0014\u0003\u0002\u0002\u0002\u0016",
    "\u0017\u0003\u0002\u0002\u0002\u0017\u0005\u0003\u0002\u0002\u0002\u0018",
    "\u0016\u0003\u0002\u0002\u0002\u0019\u001a\b\u0004\u0001\u0002\u001a",
    "\u001b\u0005\b\u0005\u0002\u001b!\u0003\u0002\u0002\u0002\u001c\u001d",
    "\f\u0004\u0002\u0002\u001d\u001e\u0007\u0005\u0002\u0002\u001e \u0005",
    "\b\u0005\u0002\u001f\u001c\u0003\u0002\u0002\u0002 #\u0003\u0002\u0002",
    "\u0002!\u001f\u0003\u0002\u0002\u0002!\"\u0003\u0002\u0002\u0002\"\u0007",
    "\u0003\u0002\u0002\u0002#!\u0003\u0002\u0002\u0002$%\u0007\u0007\u0002",
    "\u0002%(\u0005\b\u0005\u0002&(\u0005\n\u0006\u0002\'$\u0003\u0002\u0002",
    "\u0002\'&\u0003\u0002\u0002\u0002(\t\u0003\u0002\u0002\u0002)/\u0007",
    "\b\u0002\u0002*+\u0007\u0003\u0002\u0002+,\u0005\u0004\u0003\u0002,",
    "-\u0007\u0004\u0002\u0002-/\u0003\u0002\u0002\u0002.)\u0003\u0002\u0002",
    "\u0002.*\u0003\u0002\u0002\u0002/\u000b\u0003\u0002\u0002\u0002\u0007",
    "\r\u0016!\'."].join("");


var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map( function(ds, index) { return new antlr4.dfa.DFA(ds, index); });

var sharedContextCache = new antlr4.PredictionContextCache();

var literalNames = [  ];

var symbolicNames = [ null, "LPAREN", "RPAREN", "AND", "OR", "NOT", "CRITERION", 
                      "WS" ];

var ruleNames =  [ "query", "expr", "andExpr", "notExpr", "atom" ];

function SearchRegexParser (input) {
	antlr4.Parser.call(this, input);
    this._interp = new antlr4.atn.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
    this.ruleNames = ruleNames;
    this.literalNames = literalNames;
    this.symbolicNames = symbolicNames;
    return this;
}

SearchRegexParser.prototype = Object.create(antlr4.Parser.prototype);
SearchRegexParser.prototype.constructor = SearchRegexParser;

Object.defineProperty(SearchRegexParser.prototype, "atn", {
	get : function() {
		return atn;
	}
});

SearchRegexParser.EOF = antlr4.Token.EOF;
SearchRegexParser.LPAREN = 1;
SearchRegexParser.RPAREN = 2;
SearchRegexParser.AND = 3;
SearchRegexParser.OR = 4;
SearchRegexParser.NOT = 5;
SearchRegexParser.CRITERION = 6;
SearchRegexParser.WS = 7;

SearchRegexParser.RULE_query = 0;
SearchRegexParser.RULE_expr = 1;
SearchRegexParser.RULE_andExpr = 2;
SearchRegexParser.RULE_notExpr = 3;
SearchRegexParser.RULE_atom = 4;


function QueryContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchRegexParser.RULE_query;
    return this;
}

QueryContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
QueryContext.prototype.constructor = QueryContext;

QueryContext.prototype.EOF = function() {
    return this.getToken(SearchRegexParser.EOF, 0);
};

QueryContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};




SearchRegexParser.QueryContext = QueryContext;

SearchRegexParser.prototype.query = function() {

    var localctx = new QueryContext(this, this._ctx, this.state);
    this.enterRule(localctx, 0, SearchRegexParser.RULE_query);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 11;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << SearchRegexParser.LPAREN) | (1 << SearchRegexParser.NOT) | (1 << SearchRegexParser.CRITERION))) !== 0)) {
            this.state = 10;
            this.expr();
        }

        this.state = 13;
        this.match(SearchRegexParser.EOF);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ExprContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchRegexParser.RULE_expr;
    return this;
}

ExprContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ExprContext.prototype.constructor = ExprContext;

ExprContext.prototype.andExpr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(AndExprContext);
    } else {
        return this.getTypedRuleContext(AndExprContext,i);
    }
};

ExprContext.prototype.OR = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(SearchRegexParser.OR);
    } else {
        return this.getToken(SearchRegexParser.OR, i);
    }
};





SearchRegexParser.ExprContext = ExprContext;

SearchRegexParser.prototype.expr = function() {

    var localctx = new ExprContext(this, this._ctx, this.state);
    this.enterRule(localctx, 2, SearchRegexParser.RULE_expr);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 15;
        this.andExpr(0);
        this.state = 20;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===SearchRegexParser.OR) {
            this.state = 16;
            this.match(SearchRegexParser.OR);
            this.state = 17;
            this.andExpr(0);
            this.state = 22;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function AndExprContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchRegexParser.RULE_andExpr;
    return this;
}

AndExprContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
AndExprContext.prototype.constructor = AndExprContext;

AndExprContext.prototype.notExpr = function() {
    return this.getTypedRuleContext(NotExprContext,0);
};

AndExprContext.prototype.andExpr = function() {
    return this.getTypedRuleContext(AndExprContext,0);
};

AndExprContext.prototype.AND = function() {
    return this.getToken(SearchRegexParser.AND, 0);
};



SearchRegexParser.prototype.andExpr = function(_p) {
	if(_p===undefined) {
	    _p = 0;
	}
    var _parentctx = this._ctx;
    var _parentState = this.state;
    var localctx = new AndExprContext(this, this._ctx, _parentState);
    var _prevctx = localctx;
    var _startState = 4;
    this.enterRecursionRule(localctx, 4, SearchRegexParser.RULE_andExpr, _p);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 24;
        this.notExpr();
        this._ctx.stop = this._input.LT(-1);
        this.state = 31;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,2,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                if(this._parseListeners!==null) {
                    this.triggerExitRuleEvent();
                }
                _prevctx = localctx;
                localctx = new AndExprContext(this, _parentctx, _parentState);
                this.pushNewRecursionContext(localctx, _startState, SearchRegexParser.RULE_andExpr);
                this.state = 26;
                if (!( this.precpred(this._ctx, 2))) {
                    throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 2)");
                }
                this.state = 27;
                this.match(SearchRegexParser.AND);
                this.state = 28;
                this.notExpr(); 
            }
            this.state = 33;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,2,this._ctx);
        }

    } catch( error) {
        if(error instanceof antlr4.error.RecognitionException) {
	        localctx.exception = error;
	        this._errHandler.reportError(this, error);
	        this._errHandler.recover(this, error);
	    } else {
	    	throw error;
	    }
    } finally {
        this.unrollRecursionContexts(_parentctx)
    }
    return localctx;
};


function NotExprContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchRegexParser.RULE_notExpr;
    return this;
}

NotExprContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
NotExprContext.prototype.constructor = NotExprContext;

NotExprContext.prototype.NOT = function() {
    return this.getToken(SearchRegexParser.NOT, 0);
};

NotExprContext.prototype.notExpr = function() {
    return this.getTypedRuleContext(NotExprContext,0);
};

NotExprContext.prototype.atom = function() {
    return this.getTypedRuleContext(AtomContext,0);
};




SearchRegexParser.NotExprContext = NotExprContext;

SearchRegexParser.prototype.notExpr = function() {

    var localctx = new NotExprContext(this, this._ctx, this.state);
    this.enterRule(localctx, 6, SearchRegexParser.RULE_notExpr);
    try {
        this.state = 37;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case SearchRegexParser.NOT:
            this.enterOuterAlt(localctx, 1);
            this.state = 34;
            this.match(SearchRegexParser.NOT);
            this.state = 35;
            this.notExpr();
            break;
        case SearchRegexParser.LPAREN:
        case SearchRegexParser.CRITERION:
            this.enterOuterAlt(localctx, 2);
            this.state = 36;
            this.atom();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function AtomContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchRegexParser.RULE_atom;
    return this;
}

AtomContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
AtomContext.prototype.constructor = AtomContext;

AtomContext.prototype.CRITERION = function() {
    return this.getToken(SearchRegexParser.CRITERION, 0);
};

AtomContext.prototype.LPAREN = function() {
    return this.getToken(SearchRegexParser.LPAREN, 0);
};

AtomContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

AtomContext.prototype.RPAREN = function() {
    return this.getToken(SearchRegexParser.RPAREN, 0);
};




SearchRegexParser.AtomContext = AtomContext;

SearchRegexParser.prototype.atom = function() {

    var localctx = new AtomContext(this, this._ctx, this.state);
    this.enterRule(localctx, 8, SearchRegexParser.RULE_atom);
    try {
        this.state = 44;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case SearchRegexParser.CRITERION:
            this.enterOuterAlt(localctx, 1);
            this.state = 39;
            this.match(SearchRegexParser.CRITERION);
            break;
        case SearchRegexParser.LPAREN:
            this.enterOuterAlt(localctx, 2);
            this.state = 40;
            this.match(SearchRegexParser.LPAREN);
            this.state = 41;
            this.expr();
            this.state = 42;
            this.match(SearchRegexParser.RPAREN);
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


SearchRegexParser.prototype.sempred = function(localctx, ruleIndex, predIndex) {
	switch(ruleIndex) {
	case 2:
			return this.andExpr_sempred(localctx, predIndex);
    default:
        throw "No predicate with index:" + ruleIndex;
   }
};

SearchRegexParser.prototype.andExpr_sempred = function(localctx, predIndex) {
	switch(predIndex) {
		case 0:
			return this.precpred(this._ctx, 2);
		default:
			throw "No predicate with index:" + predIndex;
	}
};


SearchRegexParser.QueryContext = QueryContext;
SearchRegexParser.ExprContext = ExprContext;
SearchRegexParser.AndExprContext = AndExprContext;
SearchRegexParser.NotExprContext = NotExprContext;
export { SearchRegexParser, QueryContext, ExprContext, AndExprContext, NotExprContext, AtomContext };
SearchRegexParser.AtomContext = AtomContext;
